// check wingspanHQ/search-configuration
export enum PayerPayeeEngagementSearchableStatus {
  NotSignedUp = "NotSignedUp",
  NotEligible = "NotEligible",
  Eligible = "Eligible",
  Inactive = "Inactive"
}

export enum PayerPayeeSearchableTinStatus {
  Unverified = "Unverified",
  Pending = "Pending",
  Verified = "Verified",
  Failed = "Failed"
}
